import { FormattedNumber } from "@av/components/atoms/numbers/FormattedNumber";
import type { AvE2EProps } from "@av/components/types";
import { getCompensationFractionDigits } from "../../utils/compensation-config";

import type { CurrencyCode, PayDisplay, PayType } from "../../types";

type JobPostCompensationProps = AvE2EProps & {
  minCompensation?: number;
  maxCompensation?: number;
  currencyCode?: CurrencyCode;
  payType?: PayType;
  payDisplay?: PayDisplay;
  locale: string;
};

export function JobPostCompensation({
  minCompensation,
  maxCompensation,
  currencyCode,
  payType,
  payDisplay = "RANGE",
  locale,
  testIdPrefix,
}: JobPostCompensationProps) {
  const fractionDigits = getCompensationFractionDigits(payType);

  if (payDisplay === "AMOUNT") {
    return (
      <FormattedNumber
        testIdPrefix={`${testIdPrefix}-compensation-amount`}
        value={minCompensation?.toString() ?? ""}
        locale={locale}
        minimumFractionDigits={fractionDigits}
        maximumFractionDigits={fractionDigits}
        suffix={currencyCode}
      />
    );
  }

  return (
    <>
      <FormattedNumber
        testIdPrefix={`${testIdPrefix}-compensation-min`}
        value={minCompensation?.toString() ?? ""}
        locale={locale}
        minimumFractionDigits={fractionDigits}
        maximumFractionDigits={fractionDigits}
      />
      <span> - </span>
      <FormattedNumber
        testIdPrefix={`${testIdPrefix}-compensation-max`}
        value={maxCompensation?.toString() ?? ""}
        locale={locale}
        minimumFractionDigits={fractionDigits}
        maximumFractionDigits={fractionDigits}
        suffix={currencyCode}
      />
    </>
  );
}
